var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterestsSelected(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6359 2.48359C17.0216 1.82132 17.9784 1.82132 18.3641 2.48359L22.9356 10.3324C23.0769 10.575 23.3137 10.7471 23.5881 10.8065L32.4655 12.7288C33.2145 12.891 33.5102 13.801 32.9995 14.3725L26.9475 21.1457C26.7605 21.355 26.67 21.6334 26.6983 21.9127L27.6133 30.9496C27.6905 31.7122 26.9165 32.2745 26.2151 31.9655L17.9032 28.3027C17.6463 28.1895 17.3537 28.1895 17.0968 28.3027L8.78487 31.9655C8.08353 32.2745 7.3095 31.7122 7.38671 30.9496L8.30169 21.9127C8.32997 21.6334 8.23953 21.355 8.05247 21.1457L2.00046 14.3725C1.48981 13.801 1.78546 12.891 2.53451 12.7288L11.4119 10.8065C11.6863 10.7471 11.9231 10.575 12.0644 10.3324L16.6359 2.48359Z",
    fill: "#1F347B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestsSelected);
export default __webpack_public_path__ + "static/media/interests-selected.36ea6c57a240506ee78c0623b146b46f.svg";
export { ForwardRef as ReactComponent };